export const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
} as Intl.DateTimeFormatOptions;
